import React, { useState } from 'react';

import MainButton from '../../../components/agv-button';
import { GridSearch } from '../../../redesign-v4/components/data-grid';
import { Banner, FormSection, Panel } from '../clients-ui';
import { FeatureTree, JsonEditor } from '../feature-tree';

const selectClassName =
  'tw-h-8 tw-min-w-[260px] tw-rounded-[5px] tw-border tw-border-solid tw-border-input-border tw-bg-white tw-px-2.5 tw-text-[13px]';

/**
 * Options du client (features_v2). Les features v1 ne sont plus gérées : elles
 * ne sont lues que par les versions du mobile antérieures à 2.5.10.
 * `clientsOptions` arrive trié par identifiant.
 */
export default function OptionsStep({
  featuresV2,
  setFeaturesV2,
  defaultFeaturesV2,
  clientsOptions,
  onCopyFromClient,
  isCopying,
}) {
  const [isJsonMode, setIsJsonMode] = useState(false);
  const [sourceClientId, setSourceClientId] = useState('');
  const [search, setSearch] = useState('');

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <Panel>
        <FormSection
          title="Partir d’un client existant"
          description="Copie ses options et sa tarification, à ajuster ensuite. Ses données, logo, documents et utilisateurs ne sont pas copiés."
        >
          <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
            <select
              value={sourceClientId}
              onChange={(event) => setSourceClientId(event.target.value)}
              className={selectClassName}
            >
              <option value="">Choisir un client…</option>
              {clientsOptions.map((client) => (
                <option key={client.value} value={client.value}>
                  {client.name}
                </option>
              ))}
            </select>
            <MainButton
              variant="secondary"
              text="Copier la configuration"
              disabled={!sourceClientId}
              isLoading={isCopying}
              onClick={() => onCopyFromClient(Number(sourceClientId))}
            />
          </div>
        </FormSection>
      </Panel>

      <Panel>
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-3">
            <div className="tw-flex tw-min-w-[240px] tw-flex-1 tw-flex-col tw-gap-1">
              <p className="tw-m-0 tw-text-[13px] tw-font-semibold tw-text-text-dark-high-importance">
                Options du client
              </p>
              <p className="tw-m-0 tw-text-[12px] tw-text-[#76808c]">
                Chaque option indique ce qu’elle change et où (back-office,
                mobile, API). Ses réglages s’affichent quand elle est cochée.
              </p>
            </div>
            <MainButton
              variant="secondary"
              text={isJsonMode ? 'Vue par options' : 'Éditeur JSON'}
              onClick={() => setIsJsonMode((previous) => !previous)}
            />
            <MainButton
              variant="secondary"
              text="Valeurs par défaut"
              disabled={!defaultFeaturesV2}
              onClick={() => setFeaturesV2(defaultFeaturesV2)}
            />
          </div>

          {isJsonMode ? (
            <JsonEditor value={featuresV2} onChange={setFeaturesV2} />
          ) : (
            <>
              <GridSearch
                value={search}
                onChange={setSearch}
                placeholder="Rechercher une option (libellé, explication, clé technique)…"
              />
              <FeatureTree
                value={featuresV2}
                onChange={setFeaturesV2}
                search={search}
              />
            </>
          )}

          <Banner>
            Les options sont transmises dans le jeton de connexion : les
            utilisateurs du client les verront à leur prochaine connexion
            (l’API, elle, les relit à chaque requête).
          </Banner>
        </div>
      </Panel>
    </div>
  );
}
